'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createTemplateComponent = require('helpers/createTemplateComponent');

var _createTemplateComponent2 = _interopRequireDefault(_createTemplateComponent);

var _EnterpriseTabs = require('components/enterprise/EnterpriseTabs');

var _EnterpriseTabs2 = _interopRequireDefault(_EnterpriseTabs);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Editor = function (_Component) {
  (0, _inherits3.default)(Editor, _Component);

  function Editor() {
    (0, _classCallCheck3.default)(this, Editor);
    return (0, _possibleConstructorReturn3.default)(this, (Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).apply(this, arguments));
  }

  (0, _createClass3.default)(Editor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          activeTab = _props.activeTab,
          components = _props.components,
          id = _props.id,
          panels = _props.panels,
          setTab = _props.setTab,
          tabs = _props.tabs;


      return _react2.default.createElement(
        'div',
        { className: _styles2.default.root },
        _react2.default.createElement(
          _EnterpriseTabs2.default,
          {
            selected: activeTab,
            onBeforeChangeTab: function onBeforeChangeTab(e, prev, next) {
              setTab(next, id);
              return true;
            }
          },
          _react2.default.createElement(
            _EnterpriseTabs.TabList,
            null,
            this.props.tabs.map(function (t) {
              return _react2.default.createElement(
                _EnterpriseTabs.Tab,
                { key: t },
                t
              );
            })
          ),
          this.props.panels.map(function (p) {
            return _react2.default.createElement(
              _EnterpriseTabs.TabPanel,
              { key: p },
              _react2.default.createElement((0, _createTemplateComponent2.default)(components[p]))
            );
          })
        )
      );
    }
  }]);
  return Editor;
}(_react.Component);

exports.default = Editor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Tabs/Editor/Editor.jsx
// module id = 1555
// module chunks = 0